<template>
  <div
    class="lead-follow-up-progress"
    :aria-label="`${processed} of ${total} follow-ups processed`"
  >
    <span
      v-for="index in total"
      :key="index"
      :class="`lead-follow-up-progress__segment--${segmentState(index)}`"
    ></span>
  </div>
</template>

<script>
import { processedCount, segmentStatus } from './leadFollowUpProgress'

export default {
  name: 'LeadFollowUpProgress',
  props: {
    progress: {
      type: Object,
      default: () => ({})
    },
    state: {
      type: String,
      default: 'planned'
    },
    failed: {
      type: Boolean,
      default: false
    },
    nextStatus: {
      type: String,
      default: ''
    }
  },
  computed: {
    sent() {
      return Math.max(0, Number(this.progress.sent) || 0)
    },
    total() {
      return Math.max(0, Number(this.progress.total) || 0)
    },
    processed() {
      return processedCount(this.progress)
    }
  },
  methods: {
    segmentState(index) {
      const status = segmentStatus(this.progress, index)
      if (status === 'sent') return 'sent'
      if (status === 'sending') return 'sending'
      if (['failed', 'unknown'].includes(status)) return 'failed'
      if (['skipped', 'cancelled'].includes(status)) return 'skipped'
      if (status) return 'planned'
      if (index <= this.sent) return 'sent'
      if (index === this.sent + 1 && (this.failed || ['failed', 'unknown'].includes(this.nextStatus))) {
        return 'failed'
      }
      if (index === this.sent + 1 && this.nextStatus === 'sending') return 'sending'
      if (this.state === 'paused') return 'paused'
      return 'planned'
    }
  }
}
</script>

<style scoped>
.lead-follow-up-progress {
  display: grid;
  grid-auto-columns: minmax(8px, 1fr);
  grid-auto-flow: column;
  gap: 5px;
}

.lead-follow-up-progress span {
  height: 5px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: #dfe4df;
}

.lead-follow-up-progress__segment--sent {
  background: #58a72e !important;
}

.lead-follow-up-progress__segment--sending {
  background: #4d96c9 !important;
}

.lead-follow-up-progress__segment--failed {
  background: #c85f55 !important;
}

.lead-follow-up-progress__segment--skipped {
  background: #aeb7b2 !important;
}

.lead-follow-up-progress__segment--paused {
  border-color: #d59d42 !important;
  background: transparent !important;
}
</style>
